///////////////////////////////////////////////////////////////////////////////////
// Retrieve NOUS API Key
////////////////////////////////////////////////////////////////////////////////////
var nous_api_data;
// jQuery.ajax({
//      type: "POST",
//      // async: false,
//      url: '/wp-admin/admin-ajax.php',
//      dataType: 'json',
//      data: {
//       'action' : 'nous_retrieve_api_data',
//      },
//      success:function(response) {

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Set API Data
//         ////////////////////////////////////////////////////////////////////////////////////
//         nous_api_data = response;

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Set Global Ajax Settings
//         ////////////////////////////////////////////////////////////////////////////////////
//         jQuery.ajaxSetup({
//           headers: {
//             'X-Api-Key': response.client_key,
//           }
//         });

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Display Forms
//         ////////////////////////////////////////////////////////////////////////////////////
//         jQuery('form').css('opacity', '1');

//      },
// });

////////////////////////////////////////////////////////////////////////////////////
// Persistant Session Storage
////////////////////////////////////////////////////////////////////////////////////
if (!sessionStorage.length) {
  // Ask other tabs for session storage
  localStorage.setItem('getSessionStorage', Date.now());
};

window.addEventListener('storage', function(event) {

  if (event.key == 'getSessionStorage') {

    localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
    localStorage.removeItem('sessionStorage');

  } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
    // sessionStorage is empty -> fill it

    var data = JSON.parse(event.newValue),
          value;

    for (key in data) {
      sessionStorage.setItem(key, data[key]);
    }

  }
});

////////////////////////////////////////////////////////////////////////////////////
// Generate Google reCaptcha V3 Token
////////////////////////////////////////////////////////////////////////////////////
function generate_google_recaptcha_token(action) {
  return new Promise(function(resolve, reject) {
      grecaptcha.execute(jQuery('body').attr('data-recaptcha-key'), {
        action: action
      })
      .then(function(token) {

        ////////////////////////////////////////////////////////////////////////////////////
        // Ajax - Validate Response
        ////////////////////////////////////////////////////////////////////////////////////
        jQuery.ajax({
          type: "POST",
          url: '/wp-admin/admin-ajax.php',
          data: {
            'action':'ajax_recaptcha_validate',
            'captcha_token' : token,
            'captcha_action' : action,
          },
          success:function(response) {
            resolve(response);
          }
        });
      });
  });
}
////////////////////////////////////////////////////////////////////////////////////
// Header Offset
////////////////////////////////////////////////////////////////////////////////////
function getHeaderOffset() {

  ////////////////////////////////////////////////////////////////////////////////////
  // Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var headerOuterHeight = 0;

  ////////////////////////////////////////////////////////////////////////////////////
  // Get Sticky Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  if (jQuery('header').hasClass('js-sticky-top')) {
    headerOuterHeight = jQuery('header').outerHeight() + 20;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Return Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  return headerOuterHeight;

}

////////////////////////////////////////////////////////////////////////////////////
// Mandrill JSON Payload
////////////////////////////////////////////////////////////////////////////////////
function mandrill_json_payload(fid) {

  ////////////////////////////////////////////////////////////////////////////////////
  // Declare Form Data Object Array
  ////////////////////////////////////////////////////////////////////////////////////
  var mandrillData = new Object();
  mandrillData.customFields = {}
  var mandrillAttachments = []

  ////////////////////////////////////////////////////////////////////////////////////
  // Mandrill Settings
  ////////////////////////////////////////////////////////////////////////////////////
  mandrillData.recipients = jQuery(fid).data('form-recipients'); // Form Recipients
  mandrillData.fromName = jQuery(fid).data('form-from-name'); // From Name
  mandrillData.fromEmail = jQuery(fid).data('form-from-email-address'); // From Email Address
  mandrillData.subjectLine = jQuery(fid).data('form-subject-line'); // Form Subject Line
  mandrillData.notificationCopy = jQuery(fid).data('form-email-body'); // Email Body Copy

  ////////////////////////////////////////////////////////////////////////////////////
  // Get all data fields
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery( fid + ' *[data-field-name]' ).each(function( index, value ) {

    ////////////////////////////////////////////////////////////////////////////////////
    // Grouped Field Type - Checkboxs | Radio Buttons
    ////////////////////////////////////////////////////////////////////////////////////
    if(jQuery(this).is('[data-field-group]')) {

      var groupedID = jQuery(this).data('field-group');
      var groupedValue = [];

      ////////////////////////////////////////////////////////////////////////////////////
      // Push Array of checked fields
      ////////////////////////////////////////////////////////////////////////////////////
      jQuery( this ).find('[name="' + groupedID + '"]').each(function( index ) {
        if(jQuery(this).is(':checked')) {
          groupedValue.push(jQuery(this).val());
        }
      });

      ////////////////////////////////////////////////////////////////////////////////////
      // Append Group Data to data
      ////////////////////////////////////////////////////////////////////////////////////
      if(groupedValue.length) {
        mandrillData.customFields[jQuery(this).data('field-name')] = groupedValue.join();
      }

    ////////////////////////////////////////////////////////////////////////////////////
    // Standard Field Type
    ////////////////////////////////////////////////////////////////////////////////////
    } else {
      mandrillData.customFields[jQuery(this).data('field-name')] = jQuery(this).val();
    }

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Attachments
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery( fid + ' *[data-file-base-64]' ).each(function( index, value ) {

    mandrillAttachments.push({
      'name' : jQuery(this).attr('data-filename'),
      'type' : jQuery(this).attr('data-mimetype'),
      'content' : jQuery(this).attr('data-file-base-64')
    });

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Assign Attachments
  ////////////////////////////////////////////////////////////////////////////////////
  if(mandrillAttachments.length > 0) {
    mandrillData['attachments'] = mandrillAttachments;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Return Data
  ////////////////////////////////////////////////////////////////////////////////////
  return JSON.stringify(mandrillData);

}

////////////////////////////////////////////////////////////////////////////////////
// NOUS Anchor Link Hash
////////////////////////////////////////////////////////////////////////////////////
function nous_anchor_link_hash(hash) {
  // Exclude "Chosen" (https://harvesthq.github.io/chosen/) dropdowns from hash scroll
  // as they are not compatible with the scroll to hash functionality
  // - no hash present, results in a JS error
  if (jQuery(this).hasClass('chosen-single')) {
    return;
  }
  
  // Fixed Nav Offset
  var header_offset = getHeaderOffset();
  
  // Scroll to w/ Animation
  if(jQuery('*[data-scroll-element="' + hash + '"]').length) {
    jQuery('html, body').animate({
      scrollTop: jQuery('*[data-scroll-element="' + hash + '"]').offset().top - header_offset
    }, 0);
  }
}

////////////////////////////////////////////////////////////////////////////////////
// Document Ready
////////////////////////////////////////////////////////////////////////////////////
jQuery( document ).ready(function($) {

  ////////////////////////////////////////////////////////////////////////////////////
  // Anchor Link Hash
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', 'a', function() {

    var hash = $(this).attr('href').split('#');
    nous_anchor_link_hash(hash[1]);

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Site Wide Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var nousThemeName = $('body').attr('data-nous-theme');
  //var googleMapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}];
  var googleMapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.country","elementType":"labels.text","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":"-100"},{"lightness":"30"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"gamma":"0.00"},{"lightness":"74"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"lightness":"3"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}];

  ////////////////////////////////////////////////////////////////////////////////////
  // Determine if is retina device
  ////////////////////////////////////////////////////////////////////////////////////
  function isRetinaDisplay() {
    if (window.matchMedia) {
      var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
      return (mq && mq.matches || (window.devicePixelRatio > 1));
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Base64 File
  ////////////////////////////////////////////////////////////////////////////////////
  function base64File(file, onLoadCallback) {
      return new Promise(function(resolve, reject) {
          var reader = new FileReader();
          reader.onload = function() { resolve(reader.result); };
          reader.onerror = reject;
          reader.readAsDataURL(file);
      });
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Generate Munchkin Hash
  ////////////////////////////////////////////////////////////////////////////////////
  function generate_munchkin_hash(email) {

    return $.ajax({
      type: "POST",
      url: '/wp-admin/admin-ajax.php',
      data: 'email=' + email + '&action=generate_munchkin_hash',
      dataType: 'json',
    });

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Google Maps Init
  ////////////////////////////////////////////////////////////////////////////////////
  function init_google_map() {

    ////////////////////////////////////////////////////////////////////////////////////
    // Each Google Map
    ////////////////////////////////////////////////////////////////////////////////////
    $( '.js-init-google-map' ).each(function( index ) {

        const create_markers = false;
        ////////////////////////////////////////////////////////////////////////////////////
        // Variables
        ////////////////////////////////////////////////////////////////////////////////////
        var myLatLng = {lat: $(this).data('lat'), lng: $(this).data('lng')};
        // var mapInfoWindow = $(this).attr('data-info-window');
        // var markerIcon = new google.maps.MarkerImage('/wp-content/themes/' + nousThemeName + '/assets/img/map-marker.png', null, null, null, new google.maps.Size(30,40));


        ////////////////////////////////////////////////////////////////////////////////////
        // Create Map
        ////////////////////////////////////////////////////////////////////////////////////
        var map = new google.maps.Map(document.getElementById($(this).attr('id')), {
          zoom: 12,
          center: myLatLng,
          styles: googleMapStyles,

          zoomControl: true,              // show + / -
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER
          },
          streetViewControl: false,      // remove pegman
          mapTypeControl: false,         // remove map/satellite toggle
          fullscreenControl: false,      // optional
          rotateControl: false,          // removes circular compass
          scaleControl: false,

          disableDefaultUI: false        // IMPORTANT: must be false to allow zoomControl

        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Marker
        ////////////////////////////////////////////////////////////////////////////////////
        if(create_markers){
          var marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
          });
        }

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Info Window
        ////////////////////////////////////////////////////////////////////////////////////
        /*
        var infowindow = new google.maps.InfoWindow({
          content: mapInfoWindow,
          // pixelOffset: new google.maps.Size(5, 20)
        });
        infowindow.open(map, marker);
        */

    }); // END EACH

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Onload Functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(window).load(function() {

      ////////////////////////////////////////////////////////////////////////////////////
      // Hash Onload Scroll To Functionality
      ////////////////////////////////////////////////////////////////////////////////////
      if(window.location.hash) {

        setTimeout(function() {

          var hash = window.location.hash;
          hash = hash.split('#');

          nous_anchor_link_hash(hash[1]);

        }, 500);

      } // END HASH

      ////////////////////////////////////////////////////////////////////////////////////
      // Initialize Google Map
      ////////////////////////////////////////////////////////////////////////////////////
      init_google_map();

      ////////////////////////////////////////////////////////////////////////////////////
      // Trunc8 Function
      ////////////////////////////////////////////////////////////////////////////////////
      $( '.js-trunc8' ).each(function( index ) {

        var lineCount = $(this).attr('data-trunc8-line');

        $(this).trunk8({
          lines: parseInt(lineCount)
        });

      });

  }); // END ONLOAD


  ////////////////////////////////////////////////////////////////////////////////////
  // Clear input on focus
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('focus', '.js-clear-input', function() {

    $(this).val('');

    return false;

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Initialize Marketo Instance
  ////////////////////////////////////////////////////////////////////////////////////
  // $.ajax({
  //   url: '//munchkin.marketo.net/munchkin.js',
  //   dataType: 'script',
  //   cache: true,
  //   success: function() {
  //     Munchkin.init('[KEY]');
  //   }
  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Save To Disk Function
  ////////////////////////////////////////////////////////////////////////////////////
  // function SaveToDisk(fileURL, fileName) {
  //     // for non-IE
  //     if (!window.ActiveXObject) {
  //         var save = document.createElement('a');
  //         save.href = fileURL;
  //         save.target = '_blank';
  //         save.download = fileName || 'unknown';

  //         var evt = new MouseEvent('click', {
  //             'view': window,
  //             'bubbles': true,
  //             'cancelable': false
  //         });
  //         save.dispatchEvent(evt);

  //         (window.URL || window.webkitURL).revokeObjectURL(save.href);
  //     }

  //     // for IE < 11
  //     else if ( !! window.ActiveXObject && document.execCommand)     {
  //         var _window = window.open(fileURL, '_blank');
  //         _window.document.close();
  //         _window.document.execCommand('SaveAs', true, fileName || fileURL)
  //         _window.close();
  //     }
  // }

  ////////////////////////////////////////////////////////////////////////////////////
  // Scroll To Event
  ////////////////////////////////////////////////////////////////////////////////////
  // $(document).on('click', '.js-scroll-to', function() {

  //   // Scroll to
  //   var scrollTo = $(this).attr('data-scroll-to');

  //   // Header Position Offset
  //   if($('.header-top').css('position') === 'fixed') {
  //     var headerHeight = $('.js-navbar-fixed-top').outerHeight();
  //   } else {
  //     var headerHeight = 0;
  //   }

  //   $('html, body').animate({
  //    scrollTop: $('*[data-scroll-element="' + scrollTo + '"]').offset().top
  //   }, 0);

  //   return false;

  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Marketo IE10 Bug fix
  ////////////////////////////////////////////////////////////////////////////////////
  (function () {
    'use strict';
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
      var msViewportStyle = document.createElement('style')
      msViewportStyle.appendChild(
        document.createTextNode(
          '@-ms-viewport{width:auto!important}'
        )
      )
      document.querySelector('head').appendChild(msViewportStyle)
    }
  })();

  ////////////////////////////////////////////////////////////////////////////////////
  // File Type - Data Attributes
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change', '.js-base64-file', function() {

     ////////////////////////////////////////////////////////////////////////////////////
     // Base64 File Contents
     ////////////////////////////////////////////////////////////////////////////////////
     var inputID = $(this).attr('id');
     var fileInput = document.querySelector('#' + inputID).files[0];

     ////////////////////////////////////////////////////////////////////////////////////
     // Assign Base64 to file
     ////////////////////////////////////////////////////////////////////////////////////
     var fileInputBase64 = base64File(fileInput, function(e) {
     }).then(function(result) {
      var formatted = result.split(',');
      $('#' + inputID).attr('data-file-base-64', formatted[1]);
     });

     ////////////////////////////////////////////////////////////////////////////////////
     // Assign other attributes to file input
     ///////////////////////////////////////////////////////////////////////////////////
     $('#' + inputID).attr('data-filename', fileInput.name);
     $('#' + inputID).attr('data-mimetype', fileInput.type);

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // FAQ accordion toggle functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', '.js-panel', function() {

      $('.panel-collapse').removeClass('in');

      if($(this).parent('.panel').hasClass('active')) {
        $(this).parent('.panel').removeClass('active');
        $(this).siblings('.panel-collapse').removeClass('in');
      } else {
        $('.js-panel').parent('.panel').removeClass('active');
        $(this).parent('.panel').addClass('active');
        $(this).siblings('.panel-collapse').addClass('in');
      }

      return false;
  });

  ////////////////////////////////////////////////////////////////////////////////////
  // jQuery Validate Phone Method - Uses Google Lib
  ////////////////////////////////////////////////////////////////////////////////////
  $.validator.addMethod("validPhone", function(value, element) {

      if(value == '') { return true; }

      try {

          var phoneUtil = i18n.phonenumbers.PhoneNumberUtil.getInstance();
          var number = phoneUtil.parseAndKeepRawInput(value, 'AU');

          if(phoneUtil.isValidNumber(number)) {

              return true;

          } else {

              return false;

          }

      }
      catch(ex) {
          return false;
          console.log(ex);
      }

  }, "Please enter a valid phone number (including area code for land lines)");


  ////////////////////////////////////////////////////////////////////////////////////
  // Ticker tape
  ////////////////////////////////////////////////////////////////////////////////////
  (function ($) {
    function initFlexiTickerTape() {
      $('.js-marquee-track').each(function () {
        const $t = $(this);
        const $wrap = $t.closest('.flexi-ticker-tape-wrapper');

        // reset (re)init safe
        const $original = $t.data('originalRows') || $t.children().clone(true);
        $t.data('originalRows', $original);

        $t.stop(true, true);
        $t.removeData('marqueeInit');
        $t.empty().append($original.clone(true));

        const viewportW = $wrap.outerWidth() || $(window).width();

        // duplicate until we have enough content
        let safety = 0;
        while ($t[0].scrollWidth < viewportW * 3 && safety < 20) {
          $t.append($original.clone(true));
          safety++;
        }

        // ensure we have at least 2 full sets
        const setLen = $original.length;
        if ($t.children().length < setLen * 2) {
          $t.append($original.clone(true));
        }

        // KEY FIX: distance = left offset of first item in the 2nd set
        const $secondSetFirst = $t.children().eq(setLen);
        const distance = $secondSetFirst.position().left; // includes gap/margins properly

        $t[0].style.setProperty('--marquee-distance', distance + 'px');

        // speed control
        const pxPerSecond = parseFloat($t.data('speed')) || 110;
        const duration = Math.max(6, distance / pxPerSecond);
        $t[0].style.setProperty('--marquee-duration', duration + 's');

        $t.data('marqueeInit', true);
      });
    }
    window.initFlexiTickerTape = initFlexiTickerTape;

  })(jQuery);




  ////////////////////////////////////////////////////////////////////////////////////
  // VIDEO W/ BACKGROUND TEXT
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery(function ($) {

    $('.js-video-with-background').each(function () {

      const $wrapper = $(this);
      const $video   = $wrapper.find('video');
      const $button  = $wrapper.find('.js-video-toggle');
      const $label   = $button.find('h4');
      const videoEl  = $video.get(0);

      if (!videoEl) return;

      let hideTimer = null;

      function showButton() {
        clearTimeout(hideTimer);
        $button.removeClass('is-hidden');
      }

      function hideButton() {
        $button.addClass('is-hidden');
      }

      function startHideCountdown() {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          if (!videoEl.paused) {
            hideButton();
          }
        }, 600);
      }

      // Toggle play/pause
      $button.on('click', function () {
        if (videoEl.paused) {
          videoEl.play();
        } else {
          videoEl.pause();
        }
      });

      // Update label
      $video.on('play', function () {
        $label.text('Pause');
        showButton();
        startHideCountdown();
      });

      $video.on('pause ended', function () {
        $label.text('Play');
        showButton();
      });

      // Detect mouse movement
      $wrapper.on('mousemove', function () {
        if (!videoEl.paused) {
          showButton();
          startHideCountdown();
        }
      });

    });

  });
  



  ////////////////////////////////////////////////////////////////
  // Event Cards
  ////////////////////////////////////////////////////////////////
  $(document).on('click', '.js-event-card', function(e){
    e.preventDefault();
    const index = $(this).closest('.flexi-event-cards-content').data('index');
    const $modal = $('#eventModal');
    $modal.find('.event-modal-instance').removeClass('is-active');
    $('#event-modal-' + index).addClass('is-active');
    $modal.addClass('is-active');
    $('body').addClass('modal-open'); // 👈 lock body
  });

  $(document).on('click', '.js-modal-close', function(){
    $('#eventModal').removeClass('is-active');
    $('.event-modal-instance').removeClass('is-active');
    $('body').removeClass('modal-open'); // 👈 lock body
  });

  

  ////////////////////////////////////////////////////////////////
  // Event Carousel
  ////////////////////////////////////////////////////////////////
  (function ($) {

    function initEventCarousel() {

      $('.flexi-event-cards-wrapper').each(function () {

        const $carousel = $(this);

        // prevent double init
        if ($carousel.hasClass('flickity-enabled')) return;

        const $cells = $carousel.children('.flexi-event-cards-cell');
        const totalCells = $cells.length;

        // create dots container
        const $dots = $('<div class="event-carousel-dots"></div>');
        $carousel.after($dots);

        // create dots
        for (let i = 0; i < totalCells; i++) {
          $dots.append(`<button class="event-dot" data-index="${i}"></button>`);
        }

        const flkty = new Flickity($carousel[0], {
          cellSelector: '.flexi-event-cards-cell',
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
          contain: true,
          groupCells: 1
        });

        // activate first dot
        $dots.find('.event-dot').eq(0).addClass('is-active');

        // dot click
        $dots.on('click', '.event-dot', function () {
          const index = $(this).data('index');
          flkty.select(index);
        });

        // update active dot
        flkty.on('change', function (index) {
          $dots.find('.event-dot').removeClass('is-active')
            .eq(index).addClass('is-active');
        });

      });

    }

    $(document).ready(function () {
      initEventCarousel();
    });

  })(jQuery);



  ////////////////////////////////////////////////////////////////
  // Instagram Gallery Slider
  ////////////////////////////////////////////////////////////////
  function initInstagramCarousel($wrapper){
    const uid = $wrapper.data('cc-uid') || (`cc-${Math.random().toString(36).slice(2)}`);
    $wrapper.data('cc-uid', uid);

    const $viewport = $wrapper.find('.custom-carousel-viewport');
    const $carousel = $wrapper.find('.custom-carousel');

    const $cells = $carousel.children('.carousel-cell');
    const totalCells = $cells.length;

    const $prevBtn = $wrapper.find('.carousel-prev');
    const $nextBtn = $wrapper.find('.carousel-next');
    const $dotsTrack = $wrapper.find('.js-carousel-dots');
    const $captionOutput = $wrapper.find('#active-caption, .js-active-caption').first();

    // --- SETTINGS ---
    const enableAutoScroll = $wrapper.attr('data-autoplay') === 'true';
    const enableClicks = $wrapper.attr('data-clickable') === 'true';
    const AUTO_DELAY = 3000;

    let autoScrollTimer = null;
    let isHovered = false;

    function isCenterMode(){
      const breakpoint = parseInt($wrapper.data('center-breakpoint'), 10);
      return breakpoint && window.innerWidth <= breakpoint;
    }

function getTranslateX(index){
  const step = $cells.first().outerWidth(true);
  let x = -index * step;

  if (isCenterMode()) {
    const viewportRect = $viewport[0].getBoundingClientRect();
    const cell = $cells.first()[0];
    const cellRect = cell.getBoundingClientRect();

    const viewportCenter = viewportRect.width / 2;
    const cellCenter = (cellRect.width / 2) + 33;

    x += (viewportCenter - cellCenter);
  }

  return x;
}

    // --- CLONE ---
    if (!$carousel.data('cloned')) {
      $carousel.prepend($cells.clone());
      $carousel.append($cells.clone());
      $carousel.data('cloned', true);
    }

    let currentIndex = totalCells;
    let isAnimating = false;
    let animFrame = null;

    let isDragging = false;
    let didDrag = false;
    let startX = 0, dragDelta = 0, velocity = 0, lastX = 0, lastTime = 0;

    // --- AUTOSCROLL ---
    function startAutoScroll(){
      if (!enableAutoScroll) return;
      stopAutoScroll();
      autoScrollTimer = setInterval(() => {
        if (!isDragging && !isAnimating) {
          goToSlide(currentIndex + 1);
        }
      }, AUTO_DELAY);
    }

    function stopAutoScroll(){
      if (autoScrollTimer){
        clearInterval(autoScrollTimer);
        autoScrollTimer = null;
      }
    }

    if (enableAutoScroll) {
      $carousel
        .on('mouseenter', () => { isHovered = true; stopAutoScroll(); })
        .on('mouseleave', () => { isHovered = false; startAutoScroll(); });
    }

    // --- DOTS ---
    let $dots = $();

    function buildDots(){
      if (!$dotsTrack.length) return;
      $dotsTrack.empty();
      for (let i = 0; i < totalCells; i++){
        $dotsTrack.append(`<button class="carousel-dot" data-index="${i}"></button>`);
      }
      $dots = $dotsTrack.find('.carousel-dot');
    }

    function updateDots(){
      const realIndex = (currentIndex % totalCells + totalCells) % totalCells;
      $dots.removeClass('is-active').eq(realIndex).addClass('is-active');
    }

    function updateCaption(){
      if (!$captionOutput.length) return;
      const realIndex = (currentIndex % totalCells + totalCells) % totalCells;
      const caption = $cells.eq(realIndex).find('.carousel-caption').text();
      $captionOutput.html(`<span class="_h5">${realIndex+1}/${totalCells}</span> ${caption}`);
      updateDots();
    }

    // --- FREEZE ---
    function freezePosition() {
      const matrix = window.getComputedStyle($carousel[0]).transform;
      let currentX = -currentIndex * $cells.first().outerWidth(true);

      if (matrix && matrix !== 'none') {
        currentX = parseFloat(matrix.split(',')[4]);
      }

      $carousel.css({ transition:'none', transform:`translateX(${currentX}px)` });
      $carousel[0].offsetHeight;
      return currentX;
    }

    // --- GO TO ---
    function goToSlide(targetIndex) {
      if (isAnimating) return;
      isAnimating = true;

      const currentTransform = freezePosition();
      const distance = getTranslateX(targetIndex);
      const diff = distance - currentTransform;
      const duration = 300;

      let start = null;

      function animate(ts){
        if (!start) start = ts;
        const progress = Math.min((ts - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const pos = currentTransform + diff * eased;

        $carousel.css('transform', `translateX(${pos}px)`);

        if (progress < 1) {
          animFrame = requestAnimationFrame(animate);
        } else {

          currentIndex = targetIndex;

          if (currentIndex >= totalCells * 2) {
            currentIndex = totalCells + (currentIndex % totalCells);
          }

          if (currentIndex < totalCells) {
            currentIndex = totalCells + (currentIndex % totalCells);
            if (currentIndex < totalCells) currentIndex += totalCells;
          }

          $carousel.css({
            transition:'none',
            transform:`translateX(${getTranslateX(currentIndex)}px)`
          });

          updateCaption();
          isAnimating = false;
        }
      }

      animFrame = requestAnimationFrame(animate);
    }

    // --- BUTTONS ---
    $nextBtn.off('.cc').on('click.cc', () => {
      stopAutoScroll();
      goToSlide(currentIndex + 1);
      startAutoScroll();
    });

    $prevBtn.off('.cc').on('click.cc', () => {
      stopAutoScroll();
      goToSlide(currentIndex - 1);
      startAutoScroll();
    });

    // --- DRAG ---
    const ns = `.cc-${Math.random().toString(36).slice(2)}`;
    const DRAG_THRESHOLD = 10;

    function onMove(e){
      if (!isDragging) return;

      const x = e.type === 'touchmove'
        ? e.originalEvent.touches[0].clientX
        : e.clientX;

      const now = Date.now();
      const delta = x - lastX;
      const dt = now - lastTime || 16;

      const instantVelocity = delta / dt;

      // smooth velocity (like Flickity)
      velocity = velocity * 0.8 + instantVelocity * 0.2;
      lastX = x;
      lastTime = now;

      const targetDelta = x - startX;

      // smoothing factor (0.15–0.25 feels like Flickity)
      dragDelta += (targetDelta - dragDelta) * 0.2;

      if (Math.abs(dragDelta) > DRAG_THRESHOLD) {
        didDrag = true;
      }

      const baseX = getTranslateX(currentIndex);

      $carousel.css({
        transform: `translateX(${baseX + dragDelta}px)`,
        willChange: 'transform'
      });
    }

    function onEnd(){
      if (!isDragging) return;
      isDragging = false;

      const step = $cells.first().outerWidth(true);
      const momentum = velocity * 300; // tweak 250–400
      let moveCount = Math.round((dragDelta + momentum) / step);

      moveCount = Math.max(Math.min(moveCount, 3), -3);

      let targetIndex = currentIndex - moveCount;

      if (moveCount === 0 && Math.abs(dragDelta) > 30) {
        targetIndex = currentIndex + (dragDelta < 0 ? 1 : -1);
      }

      $(document).off(ns);
      goToSlide(targetIndex);

      setTimeout(() => { didDrag = false; }, 0);

      if (enableAutoScroll && !isHovered) startAutoScroll();

      dragDelta = 0;
      velocity = 0;
    }

    if (!enableClicks) {
      $carousel.find('a').css('pointer-events','none');
    }

    $carousel.on('click','a', function(e){
      if (!enableClicks || didDrag) e.preventDefault();
    });

    $carousel.on(`mousedown${ns} touchstart${ns}`, function(e){
      if (e.type === 'mousedown') e.preventDefault();

      stopAutoScroll();
      didDrag = false;

      if (e.type === 'mousedown' && e.button !== 0) return;
      if (isAnimating) return;

      isDragging = true;

      startX = e.type === 'touchstart'
        ? e.originalEvent.touches[0].clientX
        : e.clientX;

      lastX = startX;
      lastTime = Date.now();

      $(document)
        .on(`mousemove${ns} touchmove${ns}`, onMove)
        .on(`mouseup${ns} touchend${ns}`, onEnd);
    });

    // --- DOTS CLICK ---
    $dotsTrack.on('click','.carousel-dot', function(){
      stopAutoScroll();
      goToSlide(totalCells + parseInt(this.dataset.index));
      startAutoScroll();
    });

    // --- INIT ---
    buildDots();
    $carousel.css('transform', `translateX(${getTranslateX(currentIndex)}px)`);
    updateCaption();


    // --- Resize (FIX centering on breakpoint change) ---
let resizeTimeout;

$(window)
  .off(`resize.${uid}`)
  .on(`resize.${uid}`, function(){
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {

      const x = getTranslateX(currentIndex);

      $carousel.css({
        transition: 'none',
        transform: `translateX(${x}px)`
      });

      // force reflow (important)
      $carousel[0].offsetHeight;

      // resync UI
      updateCaption();
      updateDots();

    }, 100);
  });

    if (enableAutoScroll) startAutoScroll();
  }
  

  // Init all carousels on page
  $('.section-flexi-instagram-carousel .custom-carousel-wrapper').each(function(){
    initInstagramCarousel($(this));
  });
  

  // Flickity on mobile
  jQuery(function($){
    $('.flickity-carousel-wrapper').each(function(){
      const $wrapper = $(this);
      const breakpoint = parseInt($wrapper.data('center-breakpoint'), 10) || 991;
      const $carousel = $wrapper.find('.flickity-carousel');
      $carousel.flickity({
        cellAlign: 'center',
        contain: false,
        wrapAround: true,     // continuous loop
        draggable: true,
        prevNextButtons: false,
        pageDots: false,
        percentPosition: true,
        imagesLoaded: true,
        groupCells: false
      });
    });
  });






  //////////////////////////////////////////////////////////////
  // Logo Slider
  //////////////////////////////////////////////////////////////
  let flexiLogoSliderInstance = null;
  function flexiLogoSliderinit() {
    const carousel = document.querySelector('.js-flickity-logo-slider');
    if (!carousel) return;

    const viewportWidth = window.innerWidth;
    const isAccreditation = carousel.classList.contains('accreditations');

    const cellCount = carousel.querySelectorAll('.flexi-logo-slider-cell').length;

    let visibleCols = isAccreditation ? 4 : 5;
    if (viewportWidth < 1200) visibleCols = 3;
    if (viewportWidth < 992)  visibleCols = 2;

    const canScroll = cellCount > visibleCols;

    if (flexiLogoSliderInstance) {
      flexiLogoSliderInstance.destroy();
      flexiLogoSliderInstance = null;
    }

    const isMobile = viewportWidth < 599;

    const align = isMobile ? 'center' : 'left';

    flexiLogoSliderInstance = new Flickity(carousel, {
      cellAlign: align,
      contain: !isMobile,
      pageDots: false,
      wrapAround: true,
      autoPlay: canScroll,
      draggable: canScroll,
      prevNextButtons: false,
      imagesLoaded: false
    });

    flexiLogoSliderInstance.resize();

    const resumeAutoplay = () => {
      if (!canScroll || !flexiLogoSliderInstance) return;
      setTimeout(() => flexiLogoSliderInstance?.playPlayer(), 1200);
    };

    flexiLogoSliderInstance.on('dragEnd', resumeAutoplay);
    flexiLogoSliderInstance.on('select', resumeAutoplay);
    AOS.refreshHard();
  }
  window.flexiLogoSliderinit = flexiLogoSliderinit;



  //////////////////////////////////////////////////////////////
  // Instagram Slider
  //////////////////////////////////////////////////////////////
  let flexiInstagramSliderInstance = null;
  function flexiInstagramSliderinit() {
    const carousel = document.querySelector('.js-flickity-instagram-slider');
    if (!carousel) return;

    const viewportWidth = window.innerWidth;
    const isAccreditation = carousel.classList.contains('accreditations');

    const cellCount = carousel.querySelectorAll('.flexi-instagram-slider-cell').length;

    let visibleCols = isAccreditation ? 4 : 5;
    if (viewportWidth < 1200) visibleCols = 3;
    if (viewportWidth < 992)  visibleCols = 2;

    const canScroll = cellCount > visibleCols;

    if (flexiInstagramSliderInstance) {
      flexiInstagramSliderInstance.destroy();
      flexiInstagramSliderInstance = null;
    }

    const isMobile = viewportWidth < 599;

    const align = isMobile ? 'center' : 'left';

    flexiInstagramSliderInstance = new Flickity(carousel, {
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      wrapAround: true,
      autoPlay: canScroll,
      draggable: canScroll,
      prevNextButtons: false,
      imagesLoaded: false
    });

    flexiInstagramSliderInstance.resize();

    const resumeAutoplay = () => {
      if (!canScroll || !flexiInstagramSliderInstance) return;
      setTimeout(() => flexiInstagramSliderInstance?.playPlayer(), 1200);
    };

    flexiInstagramSliderInstance.on('dragEnd', resumeAutoplay);
    flexiInstagramSliderInstance.on('select', resumeAutoplay);
    AOS.refreshHard();
  }
  window.flexiInstagramSliderinit = flexiInstagramSliderinit;




  



// --------------------------------------------
}); // Document ready




////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Dynamic Select Module || FAQ Module
////////////////////////////////////////////////////////////////////////////////////
function flexi_category_toggle_block(
  $category_class,      // Button / Category Class
  $category_dropdown,   // Bootstrap Dropdown Class
  $category_content     // Accordion Wrapper Class
) {
  jQuery(document).ready(function ($) {

    $(document).on('click', $category_class, function () {
      var $this = $(this);
      var $faq_active_category_text = $this.text();
      var $product_variant_id = $this.attr('id');
      var $wrapper = $this.closest($category_dropdown);
    
      // Remove 'active' class from all buttons within the wrapper
      $wrapper.find($category_class).removeClass('active');
    
      // Add 'active' class to the clicked button
      $this.addClass('active');

      // Set the data-active-variant attribute of the wrapper to the clicked button's ID
      $wrapper.attr('data-active-category', $product_variant_id);

      // Update Dropdown Toggle Text
      $wrapper.parent().find('.dropdown-toggle .text').text($faq_active_category_text);
    });

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-active-category') {
          $faq_categories_content = $('body').find($category_content);
          $active_category_info = $faq_categories_content.find($category_class + '#' + mutation.target.getAttribute('data-active-category'));

          $active_category_info.siblings().addClass('d-none').removeClass('d-flex');
          $active_category_info.addClass('d-flex').removeClass('d-none');
        }
      });
    });
    
    // Observe changes to the `.js-product-variants` div
    $($category_dropdown).each(function () {
      observer.observe(this, { attributes: true });
    });

  });
}